import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import BootstrapModal from "../BootstrapModal";
import MaterialModal from "../MaterialModal";
import TreesWithSearch from "../../tree/TreesWithSearch";
import withModal from "../withModal";
import { hideModal } from "../../../actions/actionCreators";
import { clearModalTreeSearch, treeSearchUserTyped } from "../../../actions/searchActions";
import { IAppState } from "../../../types/stores/index";

type Props = {
    isOpen: boolean;
    modalProps: {
        onChange: (fieldId: string | number | null) => void;
    };
};

const FieldPickerModal: React.FC<Props> = ({ isOpen, modalProps }: Props) => {
    const dispatch = useDispatch();
    const [search, setSearch] = useState("");
    // Props
    const isInNewFlows = useSelector((state: IAppState) => state.router.location.pathname.includes("/flows"));
    const selectedField = useSelector((state: IAppState) => state.selected.field);
    const savedTreeSearch = useSelector((state: IAppState) => state.search.treeSearch);

    useEffect(() => {
        // Gets value from the search bar before removing it when the modal is up #6529
        if (savedTreeSearch != "" && search == "") {
            setSearch(savedTreeSearch);
        }
        // Cleans the search when you erase everything from the search bar #6529
        if (search != "" && savedTreeSearch == "" && !isOpen) {
            setSearch("");
        }
        //Changes the search again, if not it will be sending the previous value #6529
        if (search != "" && !isOpen) {
            setSearch(savedTreeSearch);
        }
    }, [savedTreeSearch, search, isOpen]);
    const hide = () => {
        dispatch(clearModalTreeSearch());
        if (search != "") {
            // Restores previous search #6529
            dispatch(treeSearchUserTyped(search, false));
        }
        dispatch(hideModal("FIELD_PICKER_MODAL"));
    };

    const save = () => {
        if (selectedField) {
            modalProps.onChange(selectedField);
        }
        hide();
    };

    return isInNewFlows ? (
        <MaterialModal
            id="field-picker-modal"
            isOpen={isOpen}
            title="Pick a field"
            onClose={save}
            cancelButtonText="Close"
            onPrimaryButtonRequest={save}
            showPrimaryButton={false}
        >
            <TreesWithSearch showFieldTree outerHeight="66vh" isModal />
        </MaterialModal>
    ) : (
        <BootstrapModal
            isOpen={isOpen}
            title="Pick a field"
            primaryButtonText="Submit"
            onRequestClose={hide}
            onRequestPrimary={save}
            showPrimaryButton={false}
        >
            <TreesWithSearch showFieldTree outerHeight="66vh" isModal={true} />
        </BootstrapModal>
    );
};

export default withModal(FieldPickerModal, "FIELD_PICKER_MODAL");
